module.exports = __webpack_public_path__ + "img/9788973814725.fd990d75.jpg";